import { jsx as _jsx } from "react/jsx-runtime";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails, AccordionSummary, Accordion as MuiAccordion, } from '@mui/material';
export const AccordionItem = (props) => (_jsx(MuiAccordion, { disableGutters: true, square: false, "data-slot": "accordion-item", sx: {
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-of-type': {
            borderBottom: 'none',
        },
    }, ...props }));
const DEFAULT_FOCUS_RING_COLOR = '#2563eb';
export const AccordionTrigger = ({ children, primaryColor = DEFAULT_FOCUS_RING_COLOR, sx, ...props }) => (_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { sx: { color: '#6b7280', transition: 'transform 0.2s' } }), "data-slot": "accordion-trigger", sx: {
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'space-between',
        py: 2,
        px: 0,
        fontSize: '0.875rem',
        fontWeight: 500,
        borderRadius: 1,
        outline: 'none',
        transition: 'all 0.2s',
        '&:hover': {
            textDecoration: 'underline',
        },
        '&.Mui-focusVisible': {
            boxShadow: `0 0 0 3px ${primaryColor}33`,
        },
        '&.Mui-disabled': {
            opacity: 0.5,
            pointerEvents: 'none',
        },
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(180deg)',
        },
        ...sx,
    }, ...props, children: children }));
export const AccordionContent = ({ children, sx, ...props }) => (_jsx(AccordionDetails, { "data-slot": "accordion-content", sx: {
        pt: 0,
        pb: 2,
        fontSize: '0.875rem',
        overflow: 'hidden',
        ...sx,
    }, ...props, children: children }));
